import React from "react";
import { X } from "lucide-react";
import HistoryPanel from "../history/HistoryPanel";
import SessionPanel from "../sessions/SessionPanel";

function RightPanel({
  selectedDevices,
  orientationByDevice = {},
  onRemoveDevice,
  history,
  onSelectHistory,
  onDeleteHistory,
  onClearHistory,
  sessionProps,
}) {
  return (
    <div className="right-panel-content">
      <section aria-labelledby="selected-heading">
        <h2 id="selected-heading">Selected devices ({selectedDevices.length})</h2>
        {selectedDevices.length === 0 ? (
          <p className="muted-text">Nothing selected yet.</p>
        ) : (
          <ul className="selected-device-list">
            {selectedDevices.map((device) => (
              <li key={device.id}>
                <span>
                  {device.name}{" "}
                  <span className="muted-text">
                    {orientationByDevice[device.id]
                      ? `${device.height}×${device.width}`
                      : `${device.width}×${device.height}`}
                  </span>
                </span>
                <button
                  type="button"
                  className="icon-btn"
                  aria-label={`Remove ${device.name}`}
                  onClick={() => onRemoveDevice(device.id)}
                >
                  <X size={14} strokeWidth={1.75} aria-hidden="true" />
                </button>
              </li>
            ))}
          </ul>
        )}
      </section>

      <section aria-labelledby="history-heading">
        <h2 id="history-heading">Recent URLs</h2>
        <HistoryPanel
          history={history}
          onSelect={onSelectHistory}
          onDelete={onDeleteHistory}
          onClearAll={onClearHistory}
        />
      </section>

      <section aria-labelledby="sessions-heading">
        <h2 id="sessions-heading">Saved sessions</h2>
        <SessionPanel {...sessionProps} />
      </section>
    </div>
  );
}

export default RightPanel;
